import { render, staticRenderFns } from "./wtDialog.vue?vue&type=template&id=545b791e&scoped=true"
import script from "./wtDialog.vue?vue&type=script&lang=js"
export * from "./wtDialog.vue?vue&type=script&lang=js"
import style0 from "./wtDialog.vue?vue&type=style&index=0&id=545b791e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b791e",
  null
  
)

export default component.exports